export const SocketEvent = Object.freeze({
  authorize: 'authorize',
  error: 'error',
  subscribe: 'subscribe',
  submission_updated: 'submission.updated',
});
